import { getConditionsValues } from './getConditionValues';
export const isFormVisible = (call, form, stepId) => {
    if (!form?.effects?.length)
        return true;
    return getConditionsValues(call, form, stepId).visible !== false;
};
export const getFirstVisibleFormIdx = (call, flowStep) => {
    const forms = flowStep?.flow || [];
    for (let i = 0; i < forms.length; i++) {
        if (isFormVisible(call, forms[i], flowStep.id))
            return i;
    }
    return -1;
};
export const getLastVisibleFormIdx = (call, flowStep) => {
    const forms = flowStep?.flow || [];
    for (let i = forms.length - 1; i >= 0; i--) {
        if (isFormVisible(call, forms[i], flowStep.id))
            return i;
    }
    return -1;
};
export const getNextVisibleFormIdx = (call, flowStep, fromIdx) => {
    const forms = flowStep?.flow || [];
    for (let i = fromIdx + 1; i < forms.length; i++) {
        if (isFormVisible(call, forms[i], flowStep.id))
            return i;
    }
    return -1;
};
export const getPrevVisibleFormIdx = (call, flowStep, fromIdx) => {
    const forms = flowStep?.flow || [];
    for (let i = fromIdx - 1; i >= 0; i--) {
        if (isFormVisible(call, forms[i], flowStep.id))
            return i;
    }
    return -1;
};
